import { ColDef, ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";

export const k8sCpuRequestColumnDef: ColDef = {
  field: "resource.cpu_request",
  headerName: "CPU Requests",
  cellRenderer: ({ data }: ICellRendererParams) => {
    const request = data?.resource?.cpu_request;

    if (!request) {
      return null;
    }

    return <Typography variant="body2">{request} Core</Typography>;
  },
};
